import React from 'react';
import { Heading, Link, Text } from 'bsd-react-ui-kit';

export const HELP_AND_SUPPORT_LINK =
  'http://businesshelp.comcast.com/help-and-support';
export const HELP_AND_SUPPORT_TEXT = 'Help & Support';
export const PAGE_NOT_FOUND_HEADING = 'Page Not Found';
export const PAGE_NOT_FOUND_TEXT = "We're sorry, this page does not exist.";

export default function PageNotFound() {
  const baseClass = 'bsd-page-not-found';

  return (
    <div className={baseClass}>
      <Heading
        className={`${baseClass}-heading`}
        element="h1"
        modifier="bold"
        size="l"
      >
        {PAGE_NOT_FOUND_HEADING}
      </Heading>
      <Text className={`${baseClass}-subheading`} element="p" size="xl">
        {PAGE_NOT_FOUND_TEXT}
      </Text>
      <div className={`${baseClass}-content`}>
        <Text element="p">
          Please visit the <Link to="/">My Account</Link> homepage or search{' '}
          <Link external to={HELP_AND_SUPPORT_LINK}>
            {HELP_AND_SUPPORT_TEXT}
          </Link>{' '}
          to find what you are looking for.
        </Text>
      </div>
    </div>
  );
}
